export default __webpack_public_path__ + "6d56197b7d0da34879debcd9ec70cf92.png";